import { data } from '../../svg/FilterAlt/data';
import { makeIcon } from '../makeIcon';

export const FilterAlt = makeIcon(data, 'filter_alt', 'FilterAlt');

export default FilterAlt;
